import { IApiResponse } from "src/common/ApiResponse";
import { FeatureFlags } from "src/common/FeatureFlags";
import { httpRequest } from "src/common/HttpRequest";
import { encodeGetParams, isNullOrUndefined } from "src/common/utilities/Utilities";
import { IFeatureFlagsState } from "src/state/feature-flags/types";
import authenticationService from "./AuthenticationService";

const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

// crypto.randomUUID needs a secure context and a newer browser; getRandomValues is available everywhere.
function createUserId(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

class FeatureFlagsService {
  private DEFAULT_FLAGS = FeatureFlags;
  private API_URL = process.env.REACT_APP_INTERNAL_API_BASEURL;

  public async GetFeatureFlags(): Promise<IApiResponse<IFeatureFlagsState>> {
    let userId = "";
    const uId = localStorage.getItem("npUserId");

    // replace from local storage if it exists in local storage to maintain consistent userId.
    if (!isNullOrUndefined(uId) && uId && uuidPattern.test(uId)) {
      userId = uId;
    } else {
      userId = createUserId();
      localStorage.setItem("npUserId", userId);
    }

    const token = await authenticationService.getToken();
    // Add no-cache headers to prevent browser caching
    const noCacheHeaders = {
      'Cache-Control': 'no-cache, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    };
    const response = await httpRequest(
      `${this.API_URL}/featureflags?${encodeGetParams({ names: Object.keys(this.DEFAULT_FLAGS), userId: userId, tenantId: userId })}`,
      token,
      undefined,
      'GET',
      noCacheHeaders
    );
    if (response.ok) {
      return { status: response.status, value: await response.json() };
    } else {
      throw new Error(response.statusText);
    }
  }
}

const featureFlagsService = new FeatureFlagsService();
export default featureFlagsService;
